module.exports = __webpack_public_path__ + "img/x.6cce9078.jpg";